import { useTranslation } from 'react-i18next';

import checkIcon from '@/assets/icons/faq/yes.svg';
import map from '@/assets/images/faq/map.webp';

import { Container } from '@/components/Container';
import { Title } from '@/components/Title';
import { FAQQuestion } from '@/components/FAQQuestion';
import { ContainedIcon } from '@/components/ContainedIcon';

import styles from './FAQ.module.scss';

export function FAQ() {
  const { t } = useTranslation('faq');

  const faqQuestions = t('questions', { returnObjects: true }) as {
    question: string;
    answer: string;
  }[];

  const geographyContent = t('geography', { returnObjects: true }) as {
    title: string;
    items: string[];
  };

  return (
    <section className={styles.faq} id="faq">
      <Container className={styles.faq__container}>
        <div className={styles.faq__content}>
          <Title className={styles.faq__title}>{t('title')}</Title>

          <div className={styles.faq__questions}>
            {faqQuestions.map(({ question, answer }, index) => (
              <FAQQuestion key={index} question={question} answer={answer} />
            ))}
          </div>
        </div>
        <div className={styles.geography}>
          <div className={styles.geography__content}>
            <Title className={styles.geography__title}>{geographyContent.title}</Title>
            {geographyContent.items.map((item, index) => (
              <div key={index} className={styles.geographyItem}>
                <ContainedIcon
                  className={styles.geographyItem__icon}
                  src={checkIcon}
                  alt="Check Mark"
                />
                <p className={styles.geographyItem__text}>{item}</p>
              </div>
            ))}
          </div>
          <div className={styles.geography__map}>
            <img src={map} alt="Map" loading="lazy" />
          </div>
        </div>
      </Container>
    </section>
  );
}
